<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="oneapp-button-wrapper" [class.with-secondary-icon]="secondaryIcon" [class.disabled]="disabled">
  <epg-content-header-button
    [action]="action"
    [text]="text"
    [disabled]="disabled"
    [icon]="icon"
    [type]="type"
    (buttonClick)="onClick()"
  ></epg-content-header-button>
  <fa-icon *ngIf="secondaryIcon" class="secondary-icon" [icon]="secondaryIcon"></fa-icon>
</div>
